"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockFilter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const StockFilterOptionGroup_1 = require("../StockFilterOption/StockFilterOptionGroup");
const react_1 = require("react");
const StockFilter_style_1 = require("./StockFilter.style");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
function StockFilter({ optionGroup: optionGroupProps, handleSelectedChange: handleSelectedChangeProp, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const [optionGroups, setOptionGroups] = (0, react_1.useState)(optionGroupProps);
    const handleSelectedChange = (0, react_1.useCallback)((option, optionGroup) => {
        const newOptionGroup = Object.assign(Object.assign({}, optionGroup), { options: [
                ...optionGroup.options.filter((oldOption) => oldOption.value !== option.value),
                option,
            ].sort((a, b) => a.index - b.index) });
        setOptionGroups((prev) => {
            return [
                ...prev.filter((oldOptionGroup) => oldOptionGroup.id !== optionGroup.id),
                newOptionGroup,
            ].sort((a, b) => a.index - b.index);
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(StockFilter_style_1.StyledWrapper, { children: [(0, jsx_runtime_1.jsx)(StockFilter_style_1.StyledOptionsWrapper, { children: optionGroups.map((optionGroup) => ((0, jsx_runtime_1.jsx)(StockFilterOptionGroup_1.StockFilterOptionGroup, { handleSelectedChange: (option) => handleSelectedChange(option, optionGroup), optionGroup: optionGroup }, optionGroup.id))) }), (0, jsx_runtime_1.jsx)(StockFilter_style_1.StyledButtonWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { size: 'Small', variant: 'primary', onClick: () => {
                        handleSelectedChangeProp(optionGroups);
                    }, children: t('editor.apply') }) })] }));
}
exports.StockFilter = StockFilter;
//# sourceMappingURL=StockFilter.js.map